/**
 * Audio Emotion - Global Core Engine
 * 1. UK Delivery Cutoff Engine (1:00 PM UK Time Cutoff)
 * 2. Recently Viewed Product Tracker
 */
(function() {
  'use strict';

  // 1. UK Delivery Engine
  window.ukBadgeData = window.ukBadgeData || {
    isUkVisitor: null,

    checkUkVisitor: function(callback) {
      if (window.ukBadgeData.isUkVisitor !== null) {
        callback(window.ukBadgeData.isUkVisitor);
        return;
      }

      var timeZone = '';
      try {
        timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      } catch (e) {}

      // Default to true for UK / GMT browser timezone environments
      if (timeZone.indexOf('Europe/London') !== -1 || timeZone.indexOf('GMT') !== -1) {
        window.ukBadgeData.isUkVisitor = true;
        callback(true);
        return;
      }

      fetch('/cdn-cgi/trace', { cache: 'force-cache' })
        .then(function(res) { return res.text(); })
        .then(function(data) {
          var locLine = data.split('\n').find(function(line) { return line.indexOf('loc=') === 0; });
          var countryCode = locLine ? locLine.split('=')[1] : '';
          var isGB = (countryCode === 'GB');
          window.ukBadgeData.isUkVisitor = isGB;
          callback(isGB);
        })
        .catch(function() {
          // Fallback to true if trace fails so UK testing works
          window.ukBadgeData.isUkVisitor = true;
          callback(true);
        });
    },

    getMessage: function() {
      try {
        var now = new Date();
        var dayName = new Intl.DateTimeFormat('en-GB', { weekday: 'short', timeZone: 'Europe/London' }).format(now);
        var hourStr = new Intl.DateTimeFormat('en-GB', { hour: 'numeric', hourCycle: 'h23', timeZone: 'Europe/London' }).format(now);
        var hour = parseInt(hourStr, 10);

        var isFriday = (dayName === 'Fri');
        var isWeekend = (dayName === 'Sat' || dayName === 'Sun');
        var isAfterCutoff = !isNaN(hour) && hour >= 13;

        if (isWeekend || (isFriday && isAfterCutoff)) {
          return "Ships next working day";
        } else if (isFriday && !isAfterCutoff) {
          return "Get it by Monday *";
        } else if (isAfterCutoff) {
          switch(dayName) {
            case 'Mon': return "Get it by Wednesday *";
            case 'Tue': return "Get it by Thursday *";
            case 'Wed': return "Get it by Friday *";
            case 'Thu': return "Get it by Monday *";
            default: return "Ships next working day";
          }
        } else {
          return "Get it tomorrow *";
        }
      } catch (e) {
        return "Get it tomorrow *";
      }
    },

    scanBadges: function() {
      window.ukBadgeData.checkUkVisitor(function(isUk) {
        var badges = document.querySelectorAll('.custom-delivery-badge');
        if (!badges || badges.length === 0) return;

        if (!isUk) {
          badges.forEach(function(badge) {
            badge.style.setProperty('display', 'none', 'important');
          });
          return;
        }

        var message = window.ukBadgeData.getMessage();

        badges.forEach(function(badge) {
          var textSpan = badge.querySelector('.delivery-text-target');
          var inStock = badge.getAttribute('data-in-stock') === 'true';

          if (textSpan && message && inStock) {
            textSpan.textContent = message;
            badge.style.setProperty('display', 'inline-flex', 'important');
          } else {
            badge.style.setProperty('display', 'none', 'important');
          }
        });
      });
    }
  };

  window.ukBadgeData.scanBadges();

  if (!window.hasGlobalUkDeliveryBadgeHooks) {
    window.hasGlobalUkDeliveryBadgeHooks = true;
    setInterval(window.ukBadgeData.scanBadges, 1200);
    document.addEventListener('shopify:section:load', window.ukBadgeData.scanBadges);
    document.addEventListener('DOMContentLoaded', window.ukBadgeData.scanBadges);
  }

  // 2. Recently Viewed Tracker
  function recordCurrentProductView() {
    var meta = window.aeCurrentProduct;
    if (!meta || !meta.handle) return;

    var storageKey = 'ae_recently_viewed_handles';
    var handles = [];
    try {
      handles = JSON.parse(localStorage.getItem(storageKey)) || [];
    } catch(e) {
      handles = [];
    }

    handles = handles.filter(function(h) { return h !== meta.handle; });
    handles.unshift(meta.handle);
    if (handles.length > 8) handles = handles.slice(0, 8);

    try {
      localStorage.setItem(storageKey, JSON.stringify(handles));
    } catch(e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recordCurrentProductView);
  } else {
    recordCurrentProductView();
  }
})();